import { Component } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { TranslateHelperService } from '../../services/TranslateService';
import { User } from 'src/app/models/user';
import { AppState } from 'src/app/services/app.service';

@Component({
    selector: 'error-page',
    templateUrl: './error-page.component.html',
    styleUrls: ['./error-page.component.scss'],
    standalone: false
})
export class ErrorPageComponent {
    public constructor(private appState: AppState, public _translateService: TranslateHelperService) {
        let user = this.appState.get('user') || {} as User;
        user.status = 'active';

        this.appState.updateUser(user);
    }
 }